import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const QuestionContainer = styled(Box)(
  ({ theme }) => `
  .MuiTextField-root {
    margin: 4px 8px;
    vertical-align: middle;
  }

  ${theme.breakpoints.down('md')} {
    display: flex;

    && .MuiInputBase-input {
      width: 100%;
    }

    .MuiTextField-root {
      width: 100%;
      margin: 4px 0;
    }
  }

  p {
    margin-top: 0;
    margin-bottom: 0;
  },
`,
);

export const CorrectAnswerBox = styled(Typography)<{ width: number }>(({ theme, width }) => {
  const borderColor = theme.palette.borderSuccess?.primary || '';
  const backgroundColor = theme.palette.backgroundSuccess?.primary || '';

  return `
    width: ${width + 50}px;
    display: inline-block;
    padding: 8px 16px;
    font-size: 24px;
    border: 1px solid ${borderColor};
    background-color: ${backgroundColor};
    border-radius: 4px;
    white-space: pre-wrap;
    vertical-align: middle;


    ${theme.breakpoints.down('md')} {
      display: block;
      width: 100%;

      &&{
        margin-top: 8px;
      }
    }
  `;
});
